import { render } from "./ResponderEncuesta.vue?vue&type=template&id=4857d5bc"
import script from "./ResponderEncuesta.vue?vue&type=script&lang=js"
export * from "./ResponderEncuesta.vue?vue&type=script&lang=js"

import "./ResponderEncuesta.vue?vue&type=style&index=0&id=4857d5bc&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__